import { Switch } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import { t } from "i18next";

const RatioModeField = ({ chart, handleChange, dictionary }) => {
	const handleSwitchLegend = () => {
		handleChange("request.ratioMode", !chart.request.ratioMode);
	};

	return (
		<MDBox
			mt={1}
			display="flex"
			justifyContent="space-between"
			alignItems="center"
			className="customSwitchContainer"
			onClick={() => handleSwitchLegend()}
		>
			<span>{t("CHARTS.ratioMode")}</span>
			<MDBox>
				<Switch checked={chart.request.ratioMode} />
			</MDBox>
		</MDBox>
	);
};

export default RatioModeField;
